import cep from 'cep-promise'
import { parseZipCode } from './Parser'

export const ZipCodeService = {
  async get (zipCode) {
    return cep(zipCode).then(parseZipCode)
  }
}
